type Falsy = false | null | '' | 0 | undefined;

/**
 * A simple utility for conditionally joining classNames together.
 * @param classes class names
 * @returns a concatenated string of class names
 */
export const cn = (...classes: (Falsy | string)[]): string | undefined =>
  classes?.filter(Boolean).join(' ') || undefined;
